import { render } from "./ploys.vue?vue&type=template&id=36db44e9&scoped=true"
import script from "./ploys.vue?vue&type=script&lang=js"
export * from "./ploys.vue?vue&type=script&lang=js"

import "./ploys.vue?vue&type=style&index=0&id=36db44e9&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36db44e9"]])

export default __exports__